import { extractSvgMarkup } from '../../blocks/BasicBlocks/components/iconSvg';

export default function svgIconEditorTrait(editor) {
    const tm = editor.TraitManager;

    tm.addType('svg-icon-editor', {
        noLabel: true,
        createInput({ trait }) {
            const component = trait.target;

            const wrapper = document.createElement('div');
            wrapper.style.cssText =
                'display:flex;flex-direction:column;gap:8px;width:100%;margin:4px 0;';

            const heading = document.createElement('div');
            heading.textContent = 'Icon';
            heading.style.cssText =
                'font-size:12px;font-weight:600;color:#ccc;';

            const hint = document.createElement('div');
            hint.textContent =
                'SVG hochladen oder Code einfügen. Das Icon kann jederzeit ersetzt werden.';
            hint.style.cssText =
                'font-size:11px;line-height:1.35;color:#999;';

            const uploadBtn = document.createElement('button');
            uploadBtn.type = 'button';
            uploadBtn.textContent = 'Icon ändern';
            uploadBtn.className = 'gjs-btn-prim';
            uploadBtn.style.cssText =
                'width:100%;padding:8px 12px;font-size:13px;cursor:pointer;background:#0991b2;color:#fff;border:none;border-radius:4px;';

            const fileInput = document.createElement('input');
            fileInput.type = 'file';
            fileInput.accept = '.svg,image/svg+xml';
            fileInput.hidden = true;

            const textarea = document.createElement('textarea');
            textarea.placeholder = 'SVG-Code einfügen oder ersetzen…';
            textarea.rows = 24;
            textarea.value = component.get('svgCode') || '';
            textarea.style.cssText =
                'width:100%;min-height:96px;padding:8px;font-size:12px;font-family:ui-monospace,SFMono-Regular,Menlo,monospace;line-height:1.4;border:1px solid #444;border-radius:4px;background:#1f1f1f;color:#eee;resize:vertical;box-sizing:border-box;';

            const applySvg = (raw, { allowEmpty = false } = {}) => {
                const trimmed = String(raw || '').trim();
                if (!trimmed) {
                    if (allowEmpty) {
                        component.set('svgCode', '');
                        textarea.value = '';
                    }
                    return;
                }
                const svg = extractSvgMarkup(trimmed);
                if (!svg) {
                    textarea.value = component.get('svgCode') || '';
                    return;
                }
                component.set('svgCode', svg);
                textarea.value = svg;
            };

            uploadBtn.addEventListener('click', () => fileInput.click());

            fileInput.addEventListener('change', () => {
                const file = fileInput.files?.[0];
                fileInput.value = '';
                if (!file) return;

                const reader = new FileReader();
                reader.onload = () => applySvg(String(reader.result || ''));
                reader.readAsText(file);
            });

            textarea.addEventListener('change', () =>
                applySvg(textarea.value, { allowEmpty: true })
            );
            textarea.addEventListener('blur', () =>
                applySvg(textarea.value, { allowEmpty: true })
            );

            wrapper.append(heading, hint, uploadBtn, fileInput, textarea);
            return wrapper;
        },
        onUpdate({ elInput, component }) {
            const textarea = elInput?.querySelector?.('textarea');
            if (textarea) {
                textarea.value = component.get('svgCode') || '';
            }
        },
    });
}
